module.exports = __webpack_public_path__ + "img/NL720.b7464c47.png";